import { render, staticRenderFns } from "./ConversationMenu.vue?vue&type=template&id=f96a4502"
import script from "./ConversationMenu.vue?vue&type=script&lang=js"
export * from "./ConversationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports